let CartService = (function () {
    'use strict';

    let urgent = true;
    let isValidate = true;
    let isValidateTime = true;
    let orderMinute = 0;
    let notAllCategoriesAreAvailable = true;
    let checkShopFirstTime = true;
    let startHourInNewDay = 0;
    let startMinuteInNewDay = 0;
    let endHourInNewDay = 0;
    let endMinuteInNewDay = 0;
    let isCalledCheckPromoTime = false;
    let msgForClosedShop = '';
    let msgToStopOrder = '';

    let coupon = $('.js-cart-item-coupon') === undefined ? '' : $('.js-cart-item-coupon').val();

    //Cloud Payments Data
    let cardId;
    let cryptogramPacket;
    let newCard = false;
    let isCpUsed = false;

    //Delivery Data
    let deliveryAvailable = false;
    let isDelivery;
    let minOrderPrice = 0;
    let deliveryStatus = -1;

    let deliveryHours = (((parseInt(getMinDeliveryTimeInMinutes() / 60) < 10) ? '0' : '') + parseInt(getMinDeliveryTimeInMinutes() / 60));
    if (deliveryHours === '24')
        deliveryHours = '00';
    let deliveryMinutes = (((getMinDeliveryTimeInMinutes() % 60) < 10) ? '0' : '') + getMinDeliveryTimeInMinutes() % 60;

    let pickUpHours = (((parseInt(getMinPickupTimeInMinutes() / 60) < 10) ? '0' : '')
        + parseInt(getMinPickupTimeInMinutes() / 60));
    if (pickUpHours === '24') {
        pickUpHours = '00';
    }
    var pickUpMinutes = (((getMinPickupTimeInMinutes() % 60) < 10) ? '0' : '')
        + getMinPickupTimeInMinutes() % 60;

    function getMessagesForPickUp() {

        $.ajax({
            url: '/api/v5/timeConstraints/constraints',
            type: 'GET',
            async: false,
            success: function (response) {
                if (response !== null) {
                    msgForClosedShop = response.result.messageForClosedShop;
                    msgToStopOrder = response.result.messageToStopOrder;
                }
            }
        });
    }

    function functionThatEndsUpDestroyingTheDOM() {
        $('body').removeClass('modal-open');
        $('.modal-backdrop').remove();
    }

    function checkLoyaltyProgramAccessOnPhoneChange(phone) {
        $.ajax({
            url: '/basket/check/loyalty?phone=' + phone,
            type: 'GET',
            success: function (response) {
                if (parseInt(response.code, 10) === 200 && response.result === true) {
                    $('.js-delivery-loyalty-block').show();
                    $('.js-delivery-loyalty-block-mobile').show();
                    $('.js-pickup-loyalty-block').show();
                    $('.js-pickup-loyalty-block-mobile').show();
                } else if (parseInt(response.code, 10) === 200 && response.result === false) {
                    $('.js-delivery-loyalty-block').hide();
                    $('.js-delivery-loyalty-block-mobile').hide();
                    $('.js-pickup-loyalty-block').hide();
                    $('.js-pickup-loyalty-block-mobile').hide();
                    $(".modal.in").modal('hide').on('hidden.bs.modal', functionThatEndsUpDestroyingTheDOM);
                    /*$('#phoneChangingAlert').modal('show');*/
                } else {
                    // ничего не делаем если нет ПЛ в городе
                }
            }
        });
    }

    function checkPromotionTime(time) {
        var itemsInBasket = [];
        var totalPriceInBasket = 0.0;
        $.ajax({
            url: '/getBasket',
            type: 'GET',
            async: false,
            success: function (response) {
                if (response.code === '200') {
                    totalPriceInBasket = response.result.totalPrice;
                    itemsInBasket = [];
                    $.each(response.result.items, function (index, item) {
                        var itemInBasket = {
                            id: item.id,
                            itemId: item.itemId,
                            count: item.count,
                            isWok: item.wok,
                            composites: [],
                            selectedAddons: item.selectedAddons
                        };
                        if (item.composites.length !== 0) {
                            $.each(item.composites, function (index, composite) {
                                var compositeItem = {
                                    id: composite.id,
                                    itemId: composite.itemId,
                                    count: composite.count
                                };
                                itemInBasket.composites.push(compositeItem);
                            })
                        }
                        // добавляем айтем из корзины
                        itemsInBasket.push(itemInBasket);
                    });
                    if (itemsInBasket.length !== 0) {
                        checkPromoTime(time, itemsInBasket, totalPriceInBasket)
                    }
                }
            }
        })

    }

    function checkPromoTime(time, itemsInBasket, totalPriceInBasket) {

        var userDate = time.substr(6, 2) + "." + time.substr(9, 2) + "." + time.substr(12, 4);
        var userTime = time.substr(0, 5);
        var swappedMontnAndDayTime = time.substr(0, 5) + ' ' + time.substr(9, 2) + "." + time.substr(6, 2) + "." + time.substr(12, 4);
        var dayOfTheWeek = new Date(swappedMontnAndDayTime).getDay();
        $('.js-check-promo-time-subtitle').text();
        var coupon = $('.js-cart-item-coupon') === undefined ? '' : $('.js-cart-item-coupon').val();
        var cityId = $('.js-current-cityId').val();
        var info = {
            name: '',
            phone: '',
            comment: '',
            isRecall: null,
            dateTo: userDate,
            timeTo: userTime,
            cashBack: '',
            methodOfConfirmation: null,
            payment: null,
            type: null,
            shopId: null,
            deliveryAddress: null
        };
        var deviceInfo = {
            type: 'WEB',
            deviceType: '',
            device: '',
            version: '',
            system: '',
            token: ''
        };
        var data = {
            items: itemsInBasket,
            totalPrice: totalPriceInBasket,
            coupon: coupon,
            cityId: cityId,
            info: info,
            deviceInfo: deviceInfo,
            promoItemsIds: null
        };
        $.ajax({
            url: '/api/v6/promotions/promoTime',
            type: 'POST',
            data: JSON.stringify(data),
            contentType: "application/json; charset=utf-8",
            async: false,
            success: function (response) {
                if (response.result.available === false) {
                    isValidate = false;
                    var startHour = 0;
                    var startMinute = 0;
                    var endHour = 0;
                    var endMinute = 0;
                    $.each(response.result.workingTime, function (index, item) {
                        if (dayOfTheWeek === index) {
                            startHour = item.startHour;
                            startMinute = item.startMinute === 0 ? '00' : item.startMinute;
                            endHour = item.endHour;
                            endMinute = item.endMinute === 0 ? '00' : item.endMinute;
                        }
                    });
                    var msg = "На указанное время получения заказа, акция " + response.result.title + " не доступна,\n" +
                        "акция доступна c " + startHour + ":" + startMinute +
                        " по " + endHour + ":" + endMinute;
                    $('.js-check-promo-time-subtitle').text(msg);
                    $('#courierModal').modal('hide');
                    $('#checkPromoTimeModal').modal('show');
                    isCalledCheckPromoTime = true;
                }
            }
        })
    }

    $('.js-order-info-time-to').val(deliveryHours + ":" + deliveryMinutes);
    $('.js-order-info-time-to-mobile').val(deliveryHours + ":" + deliveryMinutes);

    $('.js-time-field').val(pickUpHours + ":" + pickUpMinutes);
    $('.js-time-field-mobile').val(pickUpHours + ":" + pickUpMinutes);
    urgent = true;
    let cityId = $('.js-current-cityId').val();
    let workingTimeModel = [
        {startMinute: 0, endMinute: 0},
        {startMinute: 0, endMinute: 0},
        {startMinute: 0, endMinute: 0},
        {startMinute: 0, endMinute: 0},
        {startMinute: 0, endMinute: 0},
        {startMinute: 0, endMinute: 0},
        {startMinute: 0, endMinute: 0}
    ];

    function checkWorkingTimeModel(dataText) {

        $.ajax({
            url: '/check/workingTimeModel?date=' + dataText + '&cityId=' + cityId,
            type: 'POST',
            async: false,
            success: function (response) {
                $('.js-working-time-start-minutes').val(response.result.startMinute);
                $('.js-working-time-end-minutes').val(response.result.endMinute);
                refreshWorkingTimeLabel();
            }
        });
    }

    function checkWorkingTimeModelShop(dataText, shopId, delayToStart, minuteToStopOrder, width) {
        $.get('/check/workingTimeModel/shop?date=' + dataText + '&shopId=' + shopId, function (response) {
            startHourInNewDay = response.startHour;
            startMinuteInNewDay = response.startMinute;
            endHourInNewDay = response.endHour;
            endMinuteInNewDay = response.endMinute;
            initToStopOrderStatus(minuteToStopOrder, response.startHour,
                response.startMinute, response.endHour, response.endMinute, width,
                delayToStart);
        });
    }

    function updateWorkingTimeDays() {
        $.post('/check/workingTimeModel/day?cityId=' + cityId, function (response) {
            workingTimeModel = response;
        });
    }

    function getNowDate() {
        var d = new Date();
        var month = d.getMonth() + 1;
        var day = d.getDate();
        return (day < 10 ? '0' : '') + day + '.' + (month < 10 ? '0' : '') + month + '.' + d.getFullYear();
    }

    function equalsDate(first, second) {
        return first.getDate() === second.getDate() && first.getMonth() === second.getMonth() && first.getFullYear() === second.getFullYear();

    }

    function changeDateCourier() {
        var tomorrow = new Date();
        tomorrow.setDate(tomorrow.getDate() + 1);
        $('.js-courier-date-picker').text(tomorrow.getDate());
        $('.js-courier-date-field').val($.datepicker.formatDate("dd.mm.yy", tomorrow));
    }

    function unlockAllPaymentType() {
        $('.js-courier-pay-type-radio').removeAttr('disabled').removeClass('disabled');
    }

    function changePaymentTypeCourier() {
        $('.js-courier-pay-type-radio').attr('disabled', 'disabled').addClass('disabled');
        $('.js-courier-pay-type').removeClass('checked');
        $('.js-courier-pay-type.courier-online').addClass('checked');
        $('#courier-online').removeAttr('disabled').removeClass('disabled').prop('checked', true);
    }

    function changePaymentTypePickup() {
        $('.js-pickup-pay-type-radio').attr('disabled', 'disabled').addClass('disabled');
        $('.js-pickup-pay-type').removeClass('checked');
        $('.js-pickup-pay-type.pickup-online').addClass('checked');
        $('#pickup-online').removeAttr('disabled').removeClass('disabled').prop('checked', true);
    }

    /**
     * Минимальное время при самовывозе, при котором пользователь может получить свой заказ в минутах
     */
    function getMinPickupTimeInMinutes() {
        var element = $('.js-time-field,.js-time-field-mobile');
        var gap = element.data('pickup-constraint');
        var currentDate = new Date();
        return currentDate.getHours() * 60 + currentDate.getMinutes() + gap;
    }

    function dateToChangeCourier(dateText, inst) {
        $('.js-courier-date-picker').text(inst.currentDay);

        let time = $('.js-order-info-time-to');
        let payment = $('.js-pickup-pay-type-radio:checked');

        var width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
        if (width < 768) {
            time = $('.js-order-info-time-to-mobile');
        }
        var street = $('.js-order-info-street');
        var house = $('.js-order-info-house');
        var flat = $('.js-order-info-flat');
        var housing = $('.js-order-info-housing');
        var entrance = $('.js-order-info-entrance');
        var floor = $('.js-order-info-floor');

        var address = {
            street: street.val() === undefined ? '' : street.val(),
            house: house.val() === undefined ? '' : house.val(),
            flat: flat.val() === undefined ? '' : flat.val(),
            housing: housing.val() === undefined ? '' : housing.val(),
            entrance: entrance.val() === undefined ? '' : entrance.val(),
            floor: floor.val() === undefined ? '' : floor.val()
        };


        if (dateText == getNowDate()) {
            $('.js-courier-pay-type-radio').removeAttr('disabled').removeClass('disabled');
        } else {
            urgent = false;
            changePaymentTypeCourier();
        }

        checkWorkingTimeModel(dateText);

        showOrHideCloudContainerOf($(".js-courier-pay-online"));
    }

    function dateToChangePickup(dateText, inst) {
        $('.js-pickup-date-picker').text(inst.currentDay);

        let time = $('.js-time-field');
        let payment = $('.js-pickup-pay-type-radio:checked');
        time.removeAttr('disabled').removeClass('disabled');

        var width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
        if (width < 768) {
            time = $('.js-time-field-mobile');
        }


        if (dateText == getNowDate()) {
            $('.js-pickup-pay-type-radio').removeAttr('disabled').removeClass('disabled');
        } else {
            urgent = false;
            changePaymentTypePickup();
            var selectedOption = $('.js-shop-select option:selected');
            var width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
            if (width < 768) {
                selectedOption = $('.js-shop-select-mobile option:selected');
            }
            var element = $('.js-time-field,.js-time-field-mobile');
            var shopId = $('select.js-shop-select').val();
            var delayToStart = element.data('pickup-constraint');
            var minuteToStopOrder = selectedOption.data('minute-to-stop-order');
            checkWorkingTimeModelShop(dateText, shopId, delayToStart, minuteToStopOrder, width);
        }

        showOrHideCloudContainerOf($(".js-pickup-online"));
    }

    function enableDateTimeField() {
        $('.js-time-field').removeAttr('disabled').removeClass('disabled');
    }

    function disableDateTimeField() {
        $('.js-time-field').attr('disabled', 'disabled').addClass('disabled');
        $('.js-pickup-pay-type-radio').removeAttr('disabled').removeClass('disabled');
    }

    function onClickCheckbox() {
        $('.js-courier-order-info-recall,.js-courier-order-info-recall-mobile,.js-pickup-order-info-recall').prop('checked');
    }

    function onChangePhone() {
        var phone = $(this).val();
        var strPhone = phone.split('+').join('').split(' ').join('').split('-').join('').split('_').join('');

        checkLoyaltyProgramAccessOnPhoneChange(strPhone);

        if (strPhone.length != 11 || strPhone.charAt(1) != "9") {
            isValidate = false;
            $('.js-courier-order-info-phone,.js-pickup-order-info-phone').addClass('has-error');
            var phoneInput = $('.js-courier-order-info-phone,.js-pickup-order-info-phone');
            AppService.displayError("Некорректный номер телефона", phoneInput);
        } else {
            AppService.deleteError($('.js-courier-order-info-phone,.js-pickup-order-info-phone'));
            $('.js-pickup-order-info-phone').removeClass('has-error');
            $('.js-courier-order-info-phone').removeClass('has-error');
        }
    }

    function changeDeliveryTime() {
        var width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
        var deliveryHours = (((parseInt(getMinDeliveryTimeInMinutes() / 60) < 10) ? '0' : '')
            + parseInt(getMinDeliveryTimeInMinutes() / 60));
        if (deliveryHours === '24') {
            deliveryHours = '00';
        }
        var deliveryMinutes = (((getMinDeliveryTimeInMinutes() % 60) < 10) ? '0' : '')
            + getMinDeliveryTimeInMinutes() % 60;
        $('.js-order-info-time-to').val(deliveryHours + ":" + deliveryMinutes);
        if (width < 768) {
            $('.js-order-info-time-to-mobile').val(deliveryHours + ":" + deliveryMinutes);
        }
    }

    function changePickUpTime() {
        var width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
        var pickUpHours = (((parseInt(getMinPickupTimeInMinutes() / 60) < 10) ? '0' : '')
            + parseInt(getMinPickupTimeInMinutes() / 60));
        if (pickUpHours === '24') {
            pickUpHours = '00';
        }
        var pickUpMinutes = (((getMinPickupTimeInMinutes() % 60) < 10) ? '0' : '')
            + getMinPickupTimeInMinutes() % 60;
        $('.js-time-field').val(pickUpHours + ":" + pickUpMinutes);
        if (width < 768) {
            $('.js-time-field-mobile').val(pickUpHours + ":" + pickUpMinutes);
        }
        urgent = true;
    }

    function onChangeDeliveryTime() {
        var element = $('.js-time-js-order-info-time-to,.js-order-info-time-to-mobile');

        var infoTimeTo = $('.js-order-info-time-to');
        var dateTo = $('.js-courier-date-field.desktop');

        var width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
        if (width < 768) {
            infoTimeTo = $('.js-order-info-time-to-mobile');
            dateTo = $('.js-courier-date-field.mobile');
        }

        let dateToVal;
        if (dateTo.val())
            dateToVal = dateTo.val();
        else
            dateToVal = formatDateDMY(new Date());

        checkWorkingTimeModel(dateToVal);

        var maxDeliveryTimeGap = element.data('courier-receipt-time');
        let date = new Date(getDateFromFormat(dateToVal + ' ' + infoTimeTo.val(), 'dd.MM.yyyy HH:mm'));
        var orderTimeInMinutes = date.getHours() * 60 + date.getMinutes();
        // если количество часов равно 0 значит это новый день и мы добавляем минуты от старого
        if (date.getHours() === 0) {
            orderTimeInMinutes += 1440;
            changeDateCourier();
            checkWorkingTimeModel(getNowDate());
        }

        console.log("DATE: ", date);

        var endInMinutes = $('.js-working-time-end-minutes').val();
        if (endInMinutes !== undefined) {
            endInMinutes = parseInt(endInMinutes);
        }

        console.log("workingTime", workingTimeModel);
        /*if (orderTimeInMinutes < getMinDeliveryTimeInMinutes()
            && dateTo.val() == getNowDate()) {*/
        if (orderTimeInMinutes < getMinDeliveryTimeInMinutesForDate(date)) {
            isValidate = false;
            isValidateTime = false;
            $('.js-delivery-info').addClass('has-error-info');
            if (width < 768) {
                $('.js-delivery-info-mobile').addClass('has-error-info');
            }
        } else {
            $('.js-order-info-time-to').val();
            // $('.js-order-info-time-to').removeClass('has-error');
            $('.js-delivery-info').removeClass('has-error-info');

            if (width < 768) {
                // $('.js-order-info-time-to-mobile').removeClass('has-error');
                $('.js-order-info-time-to-mobile').val();
                $('.js-delivery-info-mobile').removeClass('has-error-info');
            }
        }

        if (dateTo.val())
            dateToVal = dateTo.val();
        else
            dateToVal = formatDateDMY(new Date());

        var minutesInDay = 1440;
        if (orderTimeInMinutes > minutesInDay && orderTimeInMinutes < endInMinutes + maxDeliveryTimeGap) {
            changeDateCourier();
            unlockAllPaymentType();
        } else if (orderTimeInMinutes + 5 > getMinDeliveryTimeInMinutes() && dateToVal !== getNowDate()) {
            changePaymentTypeCourier();
        }

        checkWorkingTime(
            date.getMinutes() + (date.getHours() * 60),
            new Date().getDate() === date.getDate()
        );
    }

    function getMinDeliveryTimeInMinutesForDate(date) {
        var dayOfWeek = date.getDay(); //day of week, sunday first day of week
        var workingTimeByDayOfWeek = workingTimeModel[dayOfWeek];

        var minutesInDay = 1440;

        var startInMinutes = workingTimeByDayOfWeek.startMinute;
        var endInMinutes = workingTimeByDayOfWeek.endMinute;

        if (startInMinutes !== undefined) {
            startInMinutes = parseInt(startInMinutes);
        }
        if (endInMinutes !== undefined) {
            endInMinutes = parseInt(endInMinutes);
        }

        var element = $('.js-time-js-order-info-time-to,.js-order-info-time-to-mobile');
        var gap = element.data('courier-constraint');

        var maxDeliveryTimeGap = element.data('courier-receipt-time');
        var currentDate = new Date();
        var time = currentDate.getHours() * 60 + currentDate.getMinutes();

        if (equalsDate(date, new Date())) {//если день сегоднешний то учитывается текущее время
            if (time < startInMinutes) {
                time = startInMinutes + gap;
                return time;
            } else {
                time = time + gap;
            }
        } else {
            time = startInMinutes + gap;
            return time;
        }


        if (time >= minutesInDay && time < endInMinutes + maxDeliveryTimeGap) {
            changeDateCourier();
        }


        return time;
    }

    function setDefaultTimeTo() {
        var infoTimeTo = $('.js-order-info-time-to,.js-order-info-time-to-mobile');
        var dateTo = $('.js-courier-date-field');

        let dateToVal;
        if (dateTo.val())
            dateToVal = dateTo.val();
        else
            dateToVal = formatDateDMY(new Date());

        var date = new Date(getDateFromFormat(dateToVal + ' ' + infoTimeTo.val(), 'dd.MM.yyyy HH:mm'));

        var deliveryHours = (((parseInt(getMinDeliveryTimeInMinutesForDate(date) / 60) < 10) ? '0' : '') + parseInt(getMinDeliveryTimeInMinutesForDate(date) / 60));
        if (deliveryHours === '24') {
            deliveryHours = '00';
        }
        var deliveryMinutes = (((getMinDeliveryTimeInMinutesForDate(date) % 60) < 10) ? '0' : '')
            + getMinDeliveryTimeInMinutesForDate(date) % 60;

        infoTimeTo.val(deliveryHours + ":" + deliveryMinutes);
    }

    function onChangePickUpTime() {
        var dateTo = $('.js-pickup-date-field.desktop');
        var time = $('.js-time-field');

        var width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
        if (width < 768) {
            time = $('.js-time-field-mobile');
            dateTo = $('.js-pickup-date-field.mobile');
        }

        let dateToVal;
        if (dateTo.val())
            dateToVal = dateTo.val();
        else
            dateToVal = formatDateDMY(new Date());

        var date = new Date(getDateFromFormat(dateToVal + ' ' + time.val(), 'dd.MM.yyyy HH:mm'));
        var orderTimeInMinutes = date.getHours() * 60 + date.getMinutes();

        if (orderTimeInMinutes + 5 < getMinPickupTimeInMinutes() && dateToVal == getNowDate()) {
            isValidate = false;
            isValidateTime = false;
            $('.js-delivery-info').addClass('has-error-info');
            if (width < 768) {
                $('.js-delivery-info-mobile').addClass('has-error-info');
            }

        } else {
            // $('.js-time-field').removeClass('has-error');
            $('.js-time-field').val();
            $('.js-delivery-info').removeClass('has-error-info');
            $('div.js-shop-select').removeClass('has-error');
            $('.js-to-stop-order-message-text').text('');
            $('.js-to-stop-order-message-error').removeClass('has-error');
            $('.js-to-stop-order-message').hide();
            if (width < 768) {
                // $('.js-time-field-mobile').removeClass('has-error');
                $('.js-time-field-mobile').val();
                $('.js-delivery-info-mobile').removeClass('has-error-info');
            }
        }

        $('select.js-shop-select').trigger('change');
    }

    function convertToClockTime(minutes) {
        minutes = parseInt(minutes);

        let hours = Math.floor(minutes / 60);
        let leftMinutes = minutes - (hours * 60);

        let hoursStr = hours.toString();

        if (hoursStr.length === 1)
            hoursStr = "0" + hoursStr;

        let minuteStr = leftMinutes.toString();
        if (minuteStr.length === 1)
            minuteStr = "0" + leftMinutes;

        return hoursStr + ":" + minuteStr;
    }

    function getStartTimeStr() {
        return convertToClockTime($('.js-working-time-start-minutes').val());
    }

    function getEndTimeStr() {
        return convertToClockTime($('.js-working-time-end-minutes').val());
    }

    function refreshWorkingTimeLabel() {
        let timeInfo = $('.js-working-time-info');

        timeInfo.html(`Время работы с ${getStartTimeStr()} по ${getEndTimeStr()}`);
    }

    function checkWorkingTime(currentOrderTimeInMinutes, today) {
        let deliveryGap = $('.js-time-js-order-info-time-to,.js-order-info-time-to-mobile').data('courier-constraint');

        let startInMinutes = $('.js-working-time-start-minutes').val();
        if (startInMinutes !== undefined) {
            startInMinutes = parseInt(startInMinutes);
        }
        let endInMinutes = $('.js-working-time-end-minutes').val();
        if (endInMinutes !== undefined) {
            endInMinutes = parseInt(endInMinutes);
        }

        let currentDate = new Date();

        let currentDateInMinute = (currentDate.getHours() * 60) + currentDate.getMinutes();

        let deliveryAvailable;

        if (urgent)
            deliveryAvailable = (currentDateInMinute >= startInMinutes &&
                currentDateInMinute <= endInMinutes);
        else {
            // Если сегодня, то можно прибавить к крайнему времени время доставки
            if (today)
                endInMinutes += deliveryGap;

            deliveryAvailable = (currentOrderTimeInMinutes >= startInMinutes &&
                currentOrderTimeInMinutes <= endInMinutes);
        }

        let timeInfoLabel = $(".js-working-time-info");

        if (!deliveryAvailable) {
            isValidate = false;
            timeInfoLabel.addClass("has-error-info");
        } else
            timeInfoLabel.removeClass("has-error-info");
    }

    function createOrder() {
        isValidate = true;
        isValidateTime = true;

        $('.js-create-order-button').attr('disabled', 'disabled').addClass('disabled');

        var data = {};

        var name;
        var phone;
        var comment;
        var isRecall;
        var payment;
        var dateTo;
        var bonusPoints;

        $('.has-error').removeClass('has-error');

        var wishes = {
            addWasabi: true,
            aadGinger: true
        };

        wishes.addWasabi = !$("#notEatWasabi").is(":checked");
        wishes.addGinger = !$("#notEatGinger").is(":checked");

        if (isDelivery) {
            name = $('.js-courier-order-info-name').val();
            phone = $('.js-courier-order-info-phone').val();
            comment = $('.js-courier-order-info-comment').val();
            isRecall = $('.js-courier-order-info-recall').prop('checked');
            payment = $('.js-courier-pay-type-radio:checked').val();
            dateTo = $('.js-courier-date-field.desktop');
            bonusPoints = $('.js-courier-loyalty-points').val();
            var userAddress = $('.js-order-info-user-address');
            var infoTimeTo = $('.js-order-info-time-to');
            var cashback = $('.js-order-info-cashback');
            var notificationDeliveryModal = $('#modalNotificationDelivery');
            var width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
            if (width < 768) {
                infoTimeTo = $('.js-order-info-time-to-mobile');
                comment = $('.js-courier-order-info-comment-mobile').val();
                isRecall = $('.js-courier-order-info-recall-mobile').prop('checked');
                dateTo = $('.js-courier-date-field.mobile');
                bonusPoints = $('.js-courier-loyalty-points-mobile').val();
            }

            if (name.length < 2) {
                isValidate = false;
                $('.js-courier-order-info-name').addClass('has-error');
            }

            var checkPhone = onChangePhone.bind($('.js-courier-order-info-phone'));

            console.log("Check Phone: ", checkPhone);
            checkPhone();

            onChangeDeliveryTime();


            let deliveryToDate;
            if (urgent) {
                let element = $('.js-time-js-order-info-time-to,.js-order-info-time-to-mobile');
                let gapInMillis = element.data('courier-constraint') * 1000 * 60;

                deliveryToDate = new Date(new Date().getTime() + gapInMillis);
            } else {
                deliveryToDate = new Date(getDateFromFormat(dateTo.val(), 'dd.MM.yyyy'));

                let time = new Date(getDateFromFormat(infoTimeTo.val(), 'HH:mm'));

                deliveryToDate.setHours(time.getHours());
                deliveryToDate.setMinutes(time.getMinutes());
            }

            let deliveryToDateStr = formatDate(deliveryToDate, "HH:mm dd.MM.yyyy");

            data = {
                isDelivery: isDelivery,
                name: name,
                phone: phone,
                comment: comment,
                isRecall: isRecall,
                coupon: coupon,
                payment: payment,
                urgent: urgent,
                customerAddress: {
                    timeTo: deliveryToDateStr,
                    cashBack: cashback.val()
                },
                bonusPoints: bonusPoints,
                wishes: wishes
            };

            if (bonusPoints === undefined) {
                data.bonusPoints = 0;
            }


            checkWorkingTime(
                deliveryToDate.getMinutes() + (deliveryToDate.getHours() * 60),
                new Date().getDate() === deliveryToDate.getDate()
            );

            if (data.customerAddress.timeTo == '') {
                isValidate = false;
                infoTimeTo.addClass('has-error');
            }

            if (userAddress.prop('selectedIndex') == 0) {
                isValidate = false;
                userAddress.addClass('has-error');
            } else {
                if (userAddress.prop('selectedIndex') == 1) {
                    var street = $('.js-order-info-street');
                    var house = $('.js-order-info-house');
                    var flat = $('.js-order-info-flat');
                    var housing = $('.js-order-info-housing');
                    var entrance = $('.js-order-info-entrance');
                    var floor = $('.js-order-info-floor');
                    var streetKladrId = $('.js-order-info-street-kladrId');
                    var houseKladrId = $('.js-order-info-house-kladrId');
                    var lat = $('.js-order-info-lat');
                    var lon = $('.js-order-info-lon');

                    data.customerAddress.street = street.val();
                    data.customerAddress.house = house.val();
                    data.customerAddress.flat = flat.val();
                    data.customerAddress.housing = housing.val();
                    data.customerAddress.entrance = entrance.val();
                    data.customerAddress.floor = floor.val();
                    if (streetKladrId !== undefined) {
                        data.customerAddress.streetKladrId = streetKladrId.val();
                    }

                    if (houseKladrId !== undefined) {
                        data.customerAddress.houseKladrId = houseKladrId.val();
                    }

                    if (lat !== undefined) {
                        data.customerAddress.lat = lat.val();
                    }

                    if (lon !== undefined) {
                        data.customerAddress.lon = lon.val();
                    }

                    // validate
                    if (data.customerAddress.street === '') {
                        isValidate = false;
                        AppService.displayError("",street)
                    }

                    if (data.customerAddress.house === '') {
                        isValidate = false;
                        AppService.displayError("",house);
                    }

                    if ((data.customerAddress.entrance.length === 0
                        || data.customerAddress.floor.length === 0)
                        && data.customerAddress.flat.length !== 0) {
                        isValidate = false;
                        isCalledCheckPromoTime = true;
                        if (data.customerAddress.floor.length === 0 && data.customerAddress.entrance.length === 0) {
                            entrance.addClass('has-error');
                            floor.addClass('has-error');
                        } else {
                            if (data.customerAddress.entrance.length === 0) {
                                entrance.addClass('has-error');
                            }
                            if (data.customerAddress.floor.length === 0) {
                                floor.addClass('has-error');
                            }
                        }

                        $('.js-entrance-and-floor-fill').show();
                    }
                } else {
                    data.customerAddress.userAddressId = userAddress.val();
                }
            }

            if (isValidateTime == false) {
                changeDeliveryTime();
            }

            if (!isCalledCheckPromoTime) {
                checkPromotionTime(data.customerAddress.timeTo);
            }

            if ($('.js-order-info-user-address').prop('selectedIndex') === 1 && !newAddressCorrect()) {
                isValidate = false;
                if (!newAddressCorrect()) {
                    glowDaDataAddressFields();
                }
            }

            checkComment($('.js-courier-order-info-comment'))
            checkComment($('.js-courier-order-info-comment-mobile'))
        } else {
            name = $('.js-pickup-order-info-name').val();
            phone = $('.js-pickup-order-info-phone').val();
            comment = $('.js-pickup-order-info-comment').val();
            isRecall = $('.js-pickup-order-info-recall').prop('checked');
            payment = $('.js-pickup-pay-type-radio:checked').val();
            dateTo = $('.js-pickup-date-field.desktop');
            bonusPoints = $('.js-pickup-loyalty-points').val();
            var address = $('select.js-shop-select');
            var time = $('.js-time-field');
            var width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
            if (width < 768) {
                time = $('.js-time-field-mobile');
                address = $('.js-shop-select-mobile');
                dateTo = $('.js-pickup-date-field.mobile');
                bonusPoints = $('.js-pickup-loyalty-points-mobile').val();
            }

            $('select.js-shop-select').trigger('change');

            if (name.length < 2) {
                isValidate = false;
                $('.js-pickup-order-info-name').addClass('has-error');
            }

            var checkPhone = onChangePhone.bind($('.js-pickup-order-info-phone'));
            checkPhone();

            onChangePickUpTime();

            let dateToVal;
            if (dateTo.val())
                dateToVal = dateTo.val();
            else
                dateToVal = formatDateDMY(new Date());

            var shopAddress = {
                address: address.val(),
                timeTo: time.val(),
                dateTo: dateToVal
            };

            if (address.prop("selectedIndex") == 0) {
                isValidate = false;
                address.addClass('has-error');
                $('.bootstrap-select>.dropdown-toggle').addClass('has-error-shop-select');
            }

            if (shopAddress.timeTo.length < 4) {
                isValidate = false;
                time.addClass('has-error');
            }

            if (name.length < 2) {
                isValidate = false;
                $('.js-order-info-name').addClass('has-error');
            }

            if (notAllCategoriesAreAvailable) {
                isValidate = false;
            }

            data = {
                isDelivery: isDelivery,
                name: name,
                phone: phone,
                comment: comment,
                coupon: coupon,
                isRecall: isRecall,
                payment: payment,
                urgent: urgent,
                shopAddress: shopAddress,
                bonusPoints: bonusPoints,
                wishes: wishes
            };

            if (bonusPoints === undefined) {
                data.bonusPoints = 0;
            }

            if (isValidateTime == false) {
                changePickUpTime();
            }

            if (!isCalledCheckPromoTime) {
                checkPromotionTime(shopAddress.timeTo + ' ' + shopAddress.dateTo);
            }
            checkComment($('.js-pickup-order-info-comment'))
        }
        //#tag: cp-submit

        if (isCpUsed === true) {
            if (newCard) {
                cryptogramPacket = createCryptogram();
                if (!cryptogramPacket)
                    isValidate = false;

                data.cryptogramPacket = cryptogramPacket;

                data.cardHolderName = isDelivery ?
                    $("#name").val() ? $("#nameCourierPayment").val().toUpperCase() : ""
                    :
                    $("#name").val() ? $("#namePickupPayment").val().toUpperCase() : "";

                data.isSaveCard = $("#checkbox1").is(':checked');
            } else {
                if (cardId)
                    data.cardId = cardId;
            }

        }


        console.log("Data: ", data);
        if (isValidate) {

            AppService.toggleLoader();
            if (payment == 'NOT_PAYED') {
                $.ajax({
                    url: '/order/payed-create',
                    type: 'POST',
                    data: JSON.stringify(data),
                    contentType: 'application/json',
                    success: function (response) {
                        if (response.code == '200') {
                            if (response.result.needRedirect) {
                                AppService.toggleLoader();
                                startRedirectInFrame(response.result.url);
                            } else
                                AppService.redirectTo(response.result.url);
                        } else {
                            $('#modalOrder').modal('hide');
                            $('.js-modal-success-message').html(response.msg);
                            AppService.toggleLoader();
                            $('#modalSuccess').modal('show');
                            $('#modalSuccess').on('hidden.bs.modal', function () {
                                AppService.redirectTo(response.result.url);
                            });
                        }
                    },
                    error: function () {
                        AppService.toggleLoader();
                        $('.js-create-order-button').removeAttr('disabled').removeClass('disabled');
                    }
                });
            } else {
                $.ajax({
                    url: '/order/create' + "?noCache=" + (new Date().getTime()) + Math.random(),
                    type: 'POST',
                    data: JSON.stringify(data),
                    contentType: 'application/json',
                    success: function (response) {
                        if (response.code == '200') {
                            AppService.redirectTo(response.result);
                        } else {
                            $('#modalOrder').modal('hide');
                            $('.js-modal-success-message').html(response.msg);

                            AppService.toggleLoader();
                            $('#modalSuccess').modal('show');
                            $('#modalSuccess').on('hidden.bs.modal', function () {
                                AppService.redirectTo(response.result);
                            });
                        }
                    },
                    error: function () {
                        AppService.toggleLoader();
                        $('.js-create-order-button').removeAttr('disabled').removeClass('disabled');
                    }
                });
            }

        }
        $('.js-create-order-button').removeAttr('disabled').removeClass('disabled');

        $("#pickupModal, #courierModal").scrollTop(0);
        return false;
    }

    function formatDateDMY(date) {
        var dd = date.getDate();
        if (dd < 10) dd = '0' + dd;

        var mm = date.getMonth() + 1;
        if (mm < 10) mm = '0' + mm;

        var yyyy = date.getFullYear();

        return dd + '.' + mm + '.' + yyyy;
    }

    //#tag: cp-function
    //**** Cloud Payments START ****

    function createCryptogram() {
        if (isDelivery) {
            $("#month").val($("#expDateCourierPayment").val().substring(0, 2));
            $("#year").val($("#expDateCourierPayment").val().substring(3, 5));
            $("#cardNumberHide").val($("#cardNumberCourierPayment").val());
            $("#cvvHide").val($("#cvvCourierPayment").val());
            $("#nameHide").val($("#nameCourierPayment").val());
        } else {
            $("#month").val($("#expDatePickupPayment").val().substring(0, 2));
            $("#year").val($("#expDatePickupPayment").val().substring(3, 5));
            $("#cardNumberHide").val($("#cardNumberPickupPayment").val());
            $("#cvvHide").val($("#cvvPickupPayment").val());
            $("#nameHide").val($("#namePickupPayment").val());
        }

        cleanAllErrors();

        var result = checkout.createCryptogramPacket();

        if (result.success) {

            return result.packet;
        } else {
            $(".loader").hide();
            for (var msgName in result.messages) {
                showError(msgName, result.messages[msgName]);
            }

            return null;
        }
    }

    function initInputMask() {
        $("#cardNumberCourierPayment").inputmask({
            'mask': '9999 9999 9999 9999',
            'oncomplete': function () {
            },
            clearMaskOnLostFocus: true,
            onBeforeMask: function (value, opts) {
            }
        });

        $("#expDateCourierPayment").inputmask({
            'mask': '99/99',
            'oncomplete': function () {
            },
            clearMaskOnLostFocus: true,
            onBeforeMask: function (value, opts) {
            }
        });

        $("#cardNumberPickupPayment").inputmask({
            'mask': '9999 9999 9999 9999',
            'oncomplete': function () {
            },
            clearMaskOnLostFocus: true,
            onBeforeMask: function (value, opts) {
            }
        });

        $("#expDatePickupPayment").inputmask({
            'mask': '99/99',
            'oncomplete': function () {
            },
            clearMaskOnLostFocus: true,
            onBeforeMask: function (value, opts) {
            }
        });
    }

    function cleanAllErrors() {
        $(".error-message").hide();

        $(".js-cp-input-class").removeClass("has-error");
    }

    function checkStatusInit() {
        if ($(".js-check-status").is(':checked')) {
            $(".payment-form-data").show();
            newCard = true;
            initInputMask();
        } else {
            $(".payment-form-data").hide();
            newCard = false;
        }
    }

    function checkStatusEvent() {
        $('input[type=radio][name=cards]').change(function () {
            if (this.value === "newCard") {
                $(".payment-form-data").show();
                cardId = null;
                newCard = true;
            } else {
                $(".payment-form-data").hide();
                cardId = this.value;
                newCard = false;
            }
        });
    }

    function checkPayTypeEvent() {
        //самовывоз
        $('input[type=radio][name=payType]').change(function () {
            if ($(".js-pickup-online").is(':checked')) {
                $(".js-cloud-container").show();
                isCpUsed = true;
            } else {
                $(".js-cloud-container").hide();
                isCpUsed = false;
            }
        });

        //курьер
        $('.js-courier-pay-type-radio').change(function () {
            if ($(".js-courier-pay-online").is(':checked')) {
                $(".js-cloud-container").show();
                isCpUsed = true;
            } else {
                $(".js-cloud-container").hide();
                isCpUsed = false;
            }
        });
    }

    function startRedirectInFrame(url) {
        $('.modal.in').modal('hide');
        $('#IFrameRedirectModal').modal('show');
        $("#IFrameRedirect").attr("src", url);
        $("#IFrameRedirect").show();


    }

    function checkPayTypeInit() {
        //для самовывоза
        if ($(".js-pickup-online").is(':checked'))
            $(".js-cloud-container").show();
        else
            $(".js-cloud-container").hide();

        //для курьера
        if ($(".js-courier-pay-online").is(':checked'))
            $(".js-cloud-container").show();
        else
            $(".js-cloud-container").hide();
    }

    function showOrHideCloudContainerOf(selector) {
        isCpUsed = selector.is(':checked');

        if (isCpUsed)
            $(".js-cloud-container").show();
        else
            $(".js-cloud-container").hide();
    }

    function showError(name, message) {
        $(".error-" + name).text(message);
        $(".error-" + name).show();

        $(".js-error-" + name).addClass("has-error");
        if (name === "expDateYear" || name === "expDateMonth")
            $(".js-error-expDate").addClass("has-error");
    }


    //**** Cloud Payments END ****

    function openOrderDialog() {
        $('.modal.in').modal('hide');
        ecommerceCheckout(2);
        if (isDelivery) {
            $('#courierModal').modal('show');
        } else {
            $('#pickupModal').modal('show');
            $('.js-delivery-proposal').hide();
            $('.js-to-stop-order-message').hide();
            $('select.js-shop-select').trigger('change');
        }

        ecommerceCheckout(3);
    }

    function initToStopOrderStatus(minuteToStopOrder, startHour, startMinute, endHour, endMinute, width, delayToStart) {
        $('.js-to-stop-order-message-text').text('');
        $('.bootstrap-select>.dropdown-toggle').removeClass('has-error-shop-select');
        $('.js-to-stop-order-message').hide();

        var toStartOrderMinuteWithoutGap = startHour * 60 + startMinute;
        var toStartOrderMinuteWithGap = toStartOrderMinuteWithoutGap + delayToStart;
        var toStopOrderMinute = endHour * 60 + endMinute;
        var workingTimeMessage = 'Время работы: с ' + startHour + ':';
        var time = $('.js-time-field');
        var dateTo = $('.js-pickup-date-field.desktop');

        let dateToVal;
        if (dateTo.val())
            dateToVal = dateTo.val();
        else
            dateToVal = formatDateDMY(new Date());

        if (width < 768) {
            time = $('.js-time-field-mobile');
            dateTo = $('.js-pickup-date-field.mobile');
        }

        getMessagesForPickUp();

        var date = new Date(getDateFromFormat(dateToVal + ' ' + time.val(), 'dd.MM.yyyy HH:mm'));
        var orderTimeInMinutes = date.getHours() * 60 + date.getMinutes();

        var currentDate = new Date();
        var currentMinutes = currentDate.getHours() * 60 + currentDate.getMinutes();

        if (startMinute < 10) workingTimeMessage += '0';
        workingTimeMessage += startMinute + ' до ' + endHour + ':';
        if (endMinute < 10) workingTimeMessage += '0';
        workingTimeMessage += endMinute + '.';

        if (orderTimeInMinutes < toStartOrderMinuteWithoutGap || orderTimeInMinutes > toStopOrderMinute) {
            isValidate = false;
            $('.bootstrap-select>.dropdown-toggle').addClass('has-error-shop-select');
            $('.js-to-stop-order-message-text').html(msgForClosedShop + ' ' + workingTimeMessage + ' <a class="js-to-stop-order-message-delivery order-message-error-href">Оформить доставку?</a>');
            $('.js-to-stop-order-message-error').addClass('has-error');
            $('.js-to-stop-order-message').show();
        } else if (orderTimeInMinutes < toStartOrderMinuteWithGap) {
            isValidate = false;
            $('.js-delivery-info').addClass('has-error-info');
        } else if ((currentMinutes > (toStopOrderMinute - minuteToStopOrder)) && equalsDay(currentDate, date)) {
            isValidate = false;
            $('.bootstrap-select>.dropdown-toggle').addClass('has-error-shop-select');
            $('.js-to-stop-order-message-text').html(msgToStopOrder + '' + workingTimeMessage + ' <a class="js-to-stop-order-message-delivery order-message-error-href">Оформить доставку?</a> ');
            $('.js-to-stop-order-message-error').addClass('has-error');
            $('.js-to-stop-order-message').show();
        } else {
            $('.bootstrap-select>.dropdown-toggle').removeClass('has-error-shop-select');
            $('.js-to-stop-order-message-text').html();
            $('.js-to-stop-order-message-error').removeClass('has-error');
            $('.js-to-stop-order-message').hide();
            $('.js-delivery-info').removeClass('has-error-info');
        }
    }

    function equalsDay(one, two) {
        const first = one;
        const second = two;

        return first.getDay() === second.getDay() && first.getMonth() === second.getMonth() && first.getFullYear() === second.getFullYear();
    }

    function checkTotalPrice(func) {
        $.ajax({
            url: '/basket/orderType/total-price',
            method: 'GET',
            contentType: 'application/json',
        }).done((response) => {
            const totalPrice = response.result;
            parseInt($('.js-cart-price').attr('data-original-price', totalPrice));
            parseInt($('.js-cart-price').text(totalPrice));

            func();
        });
    }

    //тут у нас должно быть исправление
    function initOrderDialog() {
        let notificationOrderModal = $('#modalNotificationOrder');
        let offerAuthModal = $('#modalOfferAuth');


        $('.js-offer-auth-continue').click(function () {
            if (notificationOrderModal.length > 0) {
                offerAuthModal.modal('hide');
                notificationOrderModal.modal('show');
            } else if ($('#modalCashBack').attr('active') == "true" && $('#modalCashBack').attr('promoActive') == "true") {
                offerAuthModal.modal('hide');
                $('#modalCashBack').modal('show');
            } else {
                openOrderDialog();
            }
        });
        $('.js-notification-order-continue').click(openOrderDialog);


        $('.js-cart-order-button').click(function () {
            checkDelivery(function () {
                if (isDelivery && !deliveryAvailable) {
                    showMinOrderPriceAlert();
                    return;
                }

                if (notificationOrderModal.length > 0) {
                    notificationOrderModal.modal('show');
                } else if ($('#modalCashBack').attr('active') == "true" && $('#modalCashBack').attr('promoActive') == "true") {
                    $('#modalCashBack').modal('show');
                } else {
                    openOrderDialog();
                }

                $('.js-order-sticky-part').hide();
            });

        });


        $('.js-cash-back-continue').click(function () {
            openOrderDialog();
        });

        $(".js-show-order-sticky-part").click(function () {
            showStickyPart();
        });

        $('.js-call-city-selector').click(function () {
            $('#modalOrder').modal('hide');
            $('#modalCitySelector').modal('show');
        });

        $('.js-rec-type').change(function () {
            if (this.value === 'now') {
                orderMinute = 0;
                $('select.js-shop-select').trigger('change');
                disableDateTimeField();
            } else {
                enableDateTimeField();
            }
        });

        $('.js-create-order-button').click(createOrder);

        $('.js-show-sticky-part-on-hide-modal').on('hidden.bs.modal', function () {
            showStickyPart();
        })

        initDeliveryStatus();
    }


    function initDeliverySelection() {
        $('.js-delivery-selection-courier').on('click', function () {
            ecommerceCheckout(2);
            isDelivery = true;
            $('#deliverySelectionModal').modal('hide');
            $('#courierModal').modal('show');
            ecommerceCheckout(3);
        });

        $('.js-delivery-selection-pickup').on('click', function () {
            ecommerceCheckout(2);
            isDelivery = false;
            $('#deliverySelectionModal').modal('hide');
            $('#pickupModal').modal('show');
            $('.js-delivery-proposal').hide();
            $('.js-to-stop-order-message').hide();
            $('select.js-shop-select').trigger('change');
            ecommerceCheckout(3);
        });
    }

    //вот тут у нас должно быть исправление
    function initDeliverySelectionItem() {
        $('.js-pickup-select').on('click', setPickUp);

        $('.js-courier-select').on('click', setCourier);
    }

    function setPickUp() {
        isDelivery = false;
        $('.js-courier-selection').hide();
        $('.js-pickup-selection').show();
        $('#modalCashBack').attr('active', false);
        updateWorkTimeLabel();

        showOrHideCloudContainerOf($(".js-pickup-online"));

        OrderService.getBasketSession(null, null, null, null, "OWN", null);
    }

    function setCourier() {
        checkTotalPrice(function () {
            if (!deliveryAvailable) {
                showMinOrderPriceAlert();
                isDelivery = false;
                return;
            }

            if (deliveryStatus === 0) {
                isDelivery = true;
                $('.js-pickup-selection').hide();
                $('.js-courier-selection').show();
                $('#modalCashBack').attr('active', true);

            }
            updateWorkTimeLabel();
        });

        showOrHideCloudContainerOf($(".js-courier-pay-online"));

        OrderService.getBasketSession(null, null, null, null, "DELIVERY", null);
    }

    function ecommerceCheckout(step) {
        window.dataLayer = window.dataLayer || [];
        dataLayer.push({
            'event': 'ecommerceCheckout',
            'ecommerce': {
                'checkout': {
                    'actionField': {
                        'step': step
                    },
                    'products': window.products
                }
            }
        });
    }

    /**
     * Показываем либо скрываем информацию о режиме работы
     */
    function updateWorkTimeLabel() {
        if (isDelivery == true) {
            $('.js-cart-work-time-info').show();
        } else {
            $('.js-cart-work-time-info').hide();
        }

    }

    function checkComment(element) {
        let text = element.val();
        if (text.length > 200) {
            isValidate = false;
            element.addClass('has-error');
            AppService.displayError("Длинна комментария не может быть больше 200 символов", element);
        } else {
            AppService.deleteError(element);
            element.removeClass('has-error');
            element.removeClass('has-error');

        }

    }

    let daDataErrorElement = $('.js-daData-fields-error');

    function daDataChange(element, showError) {
        if (showError && !newAddressCorrect()) {
            AppService.displayError("", element);
            daDataErrorElement.show();
        } else {
            AppService.deleteError(element);
            daDataErrorElement.hide();
        }
    }

    let streetDaDataFilled = {
        value: false,
        change: daDataChange
    };

    let houseDaDataFilled = {
        value: false,
        change: daDataChange
    };

    function glowDaDataAddressFields() {
        let streetInput = $(".js-order-info-street, .js-order-entering-address-street");
        if (streetDaDataFilled.value)
            AppService.deleteError(streetInput);
        else
            AppService.displayError("", streetInput);

        let houseInput = $(".js-order-info-house, .js-order-entering-address-house");
        if (houseDaDataFilled.value)
            AppService.deleteError(houseInput);
        else
            AppService.displayError("", houseInput);

        if (newAddressCorrect())
            daDataErrorElement.hide();
        else
            daDataErrorElement.show();
    }

    function newAddressCorrect() {
        return streetDaDataFilled.value && houseDaDataFilled.value;
    }

    function streetSuggestions() {
        let streetElements = $(".js-order-info-street, .js-order-entering-address-street");
        if (streetElements.length) {
            streetElements.autoComplete({
                minChars: 2,
                source: function (request, response) {
                    $.ajax({
                        method: 'GET',
                        url: "/api/v7/addressResolver/suggestions/street?query=" + request + "&cityId=" + $('.js-current-cityId').val(),
                        success: function (data) {
                            response($.map(data.items, function (item) {
                                let arr = [item.suggestion.value, item.suggestion.streetKladrId, item.suggestion.subValue];
                                return {
                                    arr
                                }
                            }));
                        }
                    });
                },
                renderItem: function (item, search) {
                    search = search.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
                    let re = new RegExp("(" + search.split(' ').join('|') + ")", "gi");
                    return '<div class="autocomplete-suggestion" data-val="' + item.arr[0] + '" data-street-kladr-id="' + item.arr[1] + '">' + item.arr[0].replace(re, "<b>$1</b>") + '<br><div class="sub_item_address">' + item.arr[2] + '</div> </div>';
                }
            });
            AppService.onlyAutoCompleteListElement(streetElements, $('.js-order-info-street-kladrId'), 'street-kladr-id', streetDaDataFilled);
        }
    }

    function unwrapUndefined(el) {
        if (el === undefined || el.val() === undefined) {
            return "";
        } else {
            return el.val();
        }
    }

    function houseSuggestions() {
        let houseElements = $(".js-order-info-house, .js-order-entering-address-house");
        if (houseElements.length) {
            houseElements.autoComplete({
                minChars: 1,
                source: function (request, response) {
                    $.ajax({
                        method: 'GET',
                        url: "/api/v7/addressResolver/suggestions/house?query=" + request + "&streetKladrId=" + unwrapUndefined($('.js-order-info-street-kladrId')) + "&cityId=" + $('.js-current-cityId').val(),
                        success: function (data) {
                            response($.map(data.items, function (item) {
                                var arr = [item.suggestion.value, item.suggestion.houseKladrId];
                                return {
                                    arr
                                }
                            }));
                        }
                    });
                },
                renderItem: function (item, search) {
                    search = search.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
                    var re = new RegExp("(" + search.split(' ').join('|') + ")", "gi");
                    return '<div class="autocomplete-suggestion" data-val="' + item.arr[0] + '" data-house-kladr-id="' + item.arr[1] + '">' + item.arr[0].replace(re, "<b>$1</b>") + '</div>';
                },
                onSelect: function (e, term, item) {
                    $.ajax({
                        method: 'GET',
                        url: "/api/v7/addressResolver/suggestions/house?query=" + term + "&streetKladrId=" + $('.js-order-info-street-kladrId').val() + "&cityId=" + $('.js-current-cityId').val() + "&suggestionsCount=1",
                        success: function (data) {
                            if (data.items.length !== 0) {
                                $('.js-order-info-lat').val(data.items[0].suggestion.lat);
                                $('.js-order-info-lon').val(data.items[0].suggestion.lon);
                            }
                        }
                    });
                }
            })

            AppService.onlyAutoCompleteListElement(houseElements, $('.js-order-info-house-kladrId'), 'house-kladr-id', houseDaDataFilled);
        }
    }

    //End of Address Suggestions Methods


    function initDatepicker() {

        $.datepicker.setDefaults({
            closeText: "Закрыть",
            prevText: "&#x3C;Пред",
            nextText: "След&#x3E;",
            currentText: "Сегодня",
            monthNames: ["Январь", "Февраль", "Март", "Апрель", "Май", "Июнь", "Июль", "Август", "Сентябрь", "Октябрь", "Ноябрь", "Декабрь"],
            monthNamesShort: ["Янв", "Фев", "Мар", "Апр", "Май", "Июн", "Июл", "Авг", "Сен", "Окт", "Ноя", "Дек"],
            dayNames: ["воскресенье", "понедельник", "вторник", "среда", "четверг", "пятница", "суббота"],
            dayNamesShort: ["вск", "пнд", "втр", "срд", "чтв", "птн", "сбт"],
            dayNamesMin: ["Вс", "Пн", "Вт", "Ср", "Чт", "Пт", "Сб"],
            weekHeader: "Нед",
            dateFormat: "dd.mm.yy",
            firstDay: 1,
            isRTL: false,
            showMonthAfterYear: false,
            yearSuffix: ""
        });

        enableDateTimeField();

        $('.js-courier-date-picker').click(function () {
            $('.js-date-field').datepicker('show');
        });

        $('.js-pickup-date-picker').click(function () {
            $('.js-date-field').datepicker('show');
        });


        $('.js-courier-date-field').click(function () {
            if (window.innerWidth < 350) {
                setTimeout(function () {
                    $('#ui-datepicker-div').css({
                            'left': '0',
                            'right': '0',
                            'margin': 'auto'
                        }
                    );
                }, 100);
            }
        });

        $('.js-pickup-date-field').click(function () {
            if (window.innerWidth < 350) {
                setTimeout(function () {
                    $('#ui-datepicker-div').css({
                            'left': '0',
                            'right': '0',
                            'margin': 'auto'
                        }
                    );
                }, 100);
            }
        });
        var currentDate = new Date();
        $('.js-courier-date-picker').text(currentDate.getDate());
        $('.js-pickup-date-picker').text(currentDate.getDate());
        $('.js-courier-date-field').val($.datepicker.formatDate("dd.mm.yy", currentDate));
        $('.js-pickup-date-field').val($.datepicker.formatDate("dd.mm.yy", currentDate));

        $('.js-courier-date-field').each(function () {
            $(this).datepicker({
                minDate: 0, onSelect: dateToChangeCourier,
                onClose: setDefaultTimeTo
            });
        });

        $('.js-pickup-date-field').each(function () {
            $(this).datepicker({
                minDate: 0, onSelect: dateToChangePickup
            });
        });

        applyTimeMask($('.js-time-field'));
        applyTimeMask($('.js-time-field-mobile'));
        applyTimeMask($('.js-order-info-time-to'));
        applyTimeMask($('.js-order-info-time-to-mobile'));

    }

    function applyTimeMask(element) {
        element.inputmask("datetime", {inputFormat: "HH:ss", placeholder: "_"});
    }

    function onToOrderDeliveryClick() {
        $('.js-form-pickup').on('click', '.js-to-stop-order-message-delivery', function () {
            $('#pickupModal').modal('hide');
            $('.js-courier-select').trigger('click');
            $('.js-delivery-selection-courier').trigger('click');
        })
    }

    function initializeEnteringAddress() {
        $('.js-enter-address-mobile').change(function () {
            let width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
            if (width < 768) {
                let item = $(this).val();
                if (item == "New address" || item == "Новый адрес") {
                    $('#modalEnteringAddress').modal('show');
                    $('.js-order-sticky-part').hide();
                }
            }
        });
    }

    function confirmEnteringAddress() {
        $('.js-confirm-entering-address').click(function () {

            let isValidState = true;

            if ($('.js-order-entering-address-street').val() === '') {
                isValidState = false;
                $('.js-order-entering-address-street').addClass('has-error mod-enter-address-mobile');
                $('.js-required-fields').show();
            } else {
                $('.js-order-entering-address-street').removeClass('has-error mod-enter-address-mobile');
            }

            if ($('.js-order-entering-address-house').val() === '') {
                isValidState = false;
                $('.js-order-entering-address-house').addClass('has-error mod-enter-address-mobile');
                $('.js-required-fields').show();
            } else {
                $('.js-order-entering-address-street').removeClass('has-error mod-enter-address-mobile');
            }

            if ((($('.js-order-entering-address-entrance').val().length === 0
                || $('.js-order-entering-address-floor').val().length === 0)
                && $('.js-order-entering-address-flat').val().length !== 0) && isValidState) {
                if ($('.js-order-entering-address-floor').val().length === 0 && $('.js-order-entering-address-entrance').val().length === 0) {
                    $('.js-order-entering-address-entrance').addClass('has-error mod-enter-address-mobile');
                    $('.js-order-entering-address-floor').addClass('has-error mod-enter-address-mobile');
                } else {
                    if ($('.js-order-entering-address-entrance').val().length === 0) {
                        $('.js-order-entering-address-entrance').addClass('has-error mod-enter-address-mobile');
                    }
                    if ($('.js-order-entering-address-floor').val().length === 0) {
                        $('.js-order-entering-address-floor').addClass('has-error mod-enter-address-mobile');
                    }
                }
                isValidState = false;
                $('.js-entrance-and-floor-fill-mobile').show();
            }

            if (!newAddressCorrect()) {
                isValidState = false;
                glowDaDataAddressFields();
            }

            if (isValidState) {
                let street = $('.js-order-info-street').val($('.js-order-entering-address-street').val());
                let house = $('.js-order-info-house').val($('.js-order-entering-address-house').val());
                let housing = $('.js-order-info-housing').val($('.js-order-entering-address-housing').val());
                let entrance = $('.js-order-info-entrance').val($('.js-order-entering-address-entrance').val());
                let floor = $('.js-order-info-floor').val($('.js-order-entering-address-floor').val());
                let flat = $('.js-order-info-flat').val($('.js-order-entering-address-flat').val());
                $('#modalEnteringAddress').modal('hide');
                $("body").addClass("modal-open");
                $('.js-select-type-address').hide();
                let streetStr = street.val() === '' ? '' : 'ул.' + street.val();
                let houseStr = house.val() === '' ? '' : 'д.' + house.val();
                let housingStr = housing.val() === '' ? '' : 'кор.' + housing.val();
                let entranceStr = (entrance.val() === '' || entrance.val() === '-') ? '' : 'под.' + entrance.val();
                let floorStr = (floor.val() === '' || floor.val() === '-') ? '' : 'эт.' + floor.val();
                let flatStr = flat.val() === '' ? '' : 'кв.' + flat.val();
                let strToAddress = streetStr + ' ' + houseStr + ' ' + housingStr + ' ' + entranceStr + ' ' + floorStr + ' ' + flatStr;
                $('.js-input-full-address').text(strToAddress);
                $('.js-input-full-address').css("cursor", "pointer");
                $('.js-full-address').show();
                $('.js-required-fields').hide();
            }
        });
    }

    function closeEnteringAddress() {
        $('.js-close-entering-address').click(function () {
            $('#modalEnteringAddress').modal('hide');
            $("body").addClass("modal-open");
            $('.js-select-type-address option[value="Выберите адрес"]').prop('selected', true);
        });

    }

    function resetFullAddress() {
        $('.js-reset-full-address').click(function () {
            $('.js-full-address').hide();
            $('.js-select-type-address').show();
            $('.js-select-type-address option[value="Выберите адрес"]').prop('selected', true);
        });
    }

    function editEnteringAddress() {
        $('.js-input-full-address').click(function () {
            $('#modalEnteringAddress').modal('show');
        });

    }

    function showStickyPart() {
        $('.js-order-sticky-part').show();
    }

    function changeCityFromForm() {
        $('.js-select-city-title').change(function () {
            $.post('/city/set', {title: $(this).val()}, function (result) {
                if (result === "OK") {
                    location.reload();
                }
            })
        })
    }

    function deliverySlider() {
        $('.js-courier-loyalty-points').on('input', function () {
            let lowerBound = $('.js-courier-loyalty-eggs-lower-bound');
            let upperBound = $('.js-courier-loyalty-eggs-upper-bound');
            let priceWithPoints = $('.js-courier-final-price');
            let basketPrice = priceWithPoints.data('courier-price');

            if (parseInt($(this).val()) === 0 || $(this).val() === "") {
                lowerBound.css('color', '#c7c7cd');
                lowerBound.val(0);
                upperBound.text(upperBound.data('max-eggs-courier'));
                priceWithPoints.text(basketPrice);
                $('.js-courier-points-caption').show();
                return;
            } else if (parseInt($(this).val()) > 0) {
                $('.js-courier-points-caption').hide();
            }

            var currentCountOfEggs = $(this).val();
            var difference = currentCountOfEggs - parseInt(lowerBound.val());

            if (difference > 0) {
                lowerBound.css('color', '#e40327');
                lowerBound.val(currentCountOfEggs);
                priceWithPoints.text(basketPrice - currentCountOfEggs);
                upperBound.text(upperBound.data('max-eggs-courier') - currentCountOfEggs);
            } else {
                lowerBound.css('color', '#e40327');
                lowerBound.val(currentCountOfEggs);
                priceWithPoints.text(parseInt(priceWithPoints.text(), 10) + (-difference));
                upperBound.text(parseInt(upperBound.text()) + (-difference));
            }
        });
    }

    function pickupSlider() {
        $('.js-pickup-loyalty-points').on('input', function () {
            let lowerBound = $('.js-pickup-loyalty-eggs-lower-bound');
            let upperBound = $('.js-pickup-loyalty-eggs-upper-bound');
            let priceWithPoints = $('.js-pickup-final-price');
            let basketPrice = priceWithPoints.data('pickup-price');

            if (parseInt($(this).val()) === 0 || $(this).val() === "") {
                lowerBound.css('color', '#c7c7cd');
                lowerBound.val(0);
                upperBound.text(upperBound.data('max-eggs-pickup'));
                priceWithPoints.text(basketPrice);
                $('.js-pickup-points-caption').show();
                return;
            } else if (parseInt($(this).val()) > 0) {
                $('.js-pickup-points-caption').hide();
            }
            var currentCountOfEggs = $(this).val();
            var difference = currentCountOfEggs - parseInt(lowerBound.val());

            if (difference > 0) {
                lowerBound.css('color', '#e40327');
                lowerBound.val(currentCountOfEggs);
                priceWithPoints.text(basketPrice - currentCountOfEggs);
                upperBound.text(upperBound.data('max-eggs-pickup') - currentCountOfEggs);
            } else {
                lowerBound.css('color', '#e40327');
                lowerBound.val(currentCountOfEggs);
                priceWithPoints.text(parseInt(priceWithPoints.text(), 10) + (-difference));
                upperBound.text(parseInt(upperBound.text()) + (-difference));
            }
        });
    }

    //Delivery Methods

    //main
    function externalUpdateDeliveryStatus(deliveryAvailableVar) {
        const valueChanged = deliveryAvailable !== deliveryAvailableVar;

        deliveryAvailable = deliveryAvailableVar;

        if (valueChanged) {
            if (deliveryAvailable)
                setCourier();
            else
                setPickUp();
        }
    }

    /**
     * Минимальное время при доставке, на которое пользователь может ее произвести в минутах
     */
    function getMinDeliveryTimeInMinutes() {
        var minutesInDay = 1440;

        var startInMinutes = $('.js-working-time-start-minutes').val();
        var endInMinutes = $('.js-working-time-end-minutes').val();

        if (startInMinutes !== undefined) {
            startInMinutes = parseInt(startInMinutes);
        }
        if (endInMinutes !== undefined) {
            endInMinutes = parseInt(endInMinutes);
        }

        var element = $('.js-time-js-order-info-time-to,.js-order-info-time-to-mobile');
        var gap = element.data('courier-constraint');

        var maxDeliveryTimeGap = element.data('courier-receipt-time');
        var currentDate = new Date();
        var time = currentDate.getHours() * 60 + currentDate.getMinutes();

        if (time < startInMinutes) {
            time = startInMinutes + gap;
            return time;
        } else {
            time = time + gap;
        }

        if (time >= minutesInDay && time < endInMinutes + maxDeliveryTimeGap) {
            // timeBeforeMidnightInMinutes = time - gap;
            changeDateCourier();
        }


        return time;
    }

    function initDeliveryStatus() {
        deliveryStatus = parseInt($('#deliverySelectionModal').data('deliveryStatus'));
        isDelivery = deliveryStatus === 0;

        if ($('.js-order-info-user-address').prop('selectedIndex') == 1) {
            $('.js-delivery-custom-address-field').show();
        } else {
            $('.js-delivery-custom-address-field').hide();
        }

        $('.js-order-info-user-address').change(function () {
            if ($('.js-order-info-user-address').prop('selectedIndex') == 1) {
                $('.js-delivery-custom-address-field').show();
            } else {
                $('.js-delivery-custom-address-field').hide();
            }
        });

        $('.js-courier-pay-type-radio').change(function () {
            $('.js-courier-pay-type').removeClass('checked').filter('.' + this.id).addClass('checked');

            var date = $('.js-courier-date-field.desktop');
            var time = $('.js-order-info-time-to');
            var payment = $(this);
            var width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
            if (width < 768) {
                date = $('.js-courier-date-field.mobile');
                time = $('.js-order-info-time-to-mobile');
            }
            time.removeAttr('disabled').removeClass('disabled');

            var street = $('.js-order-info-street');
            var house = $('.js-order-info-house');
            var flat = $('.js-order-info-flat');
            var housing = $('.js-order-info-housing');
            var entrance = $('.js-order-info-entrance');
            var floor = $('.js-order-info-floor');

            var address = {
                street: street.val() === undefined ? '' : street.val(),
                house: house.val() === undefined ? '' : house.val(),
                flat: flat.val() === undefined ? '' : flat.val(),
                housing: housing.val() === undefined ? '' : housing.val(),
                entrance: entrance.val() === undefined ? '' : entrance.val(),
                floor: floor.val() === undefined ? '' : floor.val()
            };

        });

        $('.js-pickup-pay-type-radio').change(function () {
            $('.js-pickup-pay-type').removeClass('checked').filter('.' + this.id).addClass('checked');

            var date = $('.js-pickup-date-field.desktop');
            var time = $('.js-time-field');
            var payment = $(this);
            var width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
            if (width < 768) {
                date = $('.js-pickup-date-field.mobile');
                time = $('.js-time-field-mobile');
            }
            time.removeAttr('disabled').removeClass('disabled');

        });
    }

    function checkOrderType() {
        $.ajax({
            url: '/basket/orderType/check',
            method: 'GET',
            contentType: 'application/json',
        }).done((response) => {
            isDelivery = response.result;
        });
    }

    function getMinOrderPrice() {
        $.ajax({
            url: '/basket/orderPrice/get',
            method: 'GET',
            contentType: 'application/json',
        }).done((response) => {
            minOrderPrice = response.result;
        });
    }

    function checkDelivery(func) {
        $.ajax({
            url: '/basket/orderType/check',
            method: 'GET',
            contentType: 'application/json',
        }).done((response) => {
            //isDelivery = response.result;
            func();
        });
    }

    function showMinOrderPriceAlert() {
        $('.js-check-price-title').text('Внимание!');
        $('.js-check-price-body').text(
            'Боимся что ты останешься голодным. ' +
            'Закажи ещё! Теперь мы возим от суммы заказа ' + minOrderPrice + ' ₽'
        );

        OrderService.addAndShow("checkPriceModal");
    }

    //End of Delivery Methods


    let courierUrgentSelect = $('.js-courier-urgent');
    let courierUrgentCheckbox = $('.js-delivery_urgent_mobile');

    function initDeliveryUrgentSelect() {
        refreshDeliveryDateToField(true);

        courierUrgentSelect.change(function () {
            refreshDeliveryDateToField(this.value === "true");
        });

        courierUrgentCheckbox.change(function () {
            refreshDeliveryDateToField(this.checked);
        });


        $('.js-courier_date_select').click(function () {
            $(".js-courier-urgent[value=false]").prop("checked", true);
        });
    }

    function resetCourierDate() {

        let today = new Date();


        $('.js-courier-date-picker').text(today.getDate());
        $('.js-courier-date-field').val($.datepicker.formatDate("dd.mm.yy", today));
        changePaymentTypeCourier();
    }


    function refreshDeliveryDateToField(urgentValue) {
        if (urgentValue) {
            $('.js-delivery-to-date').hide('slow');
            courierUrgentCheckbox.prop("checked", true);
            $('.js-courier-urgent[value=true]').prop("checked", true);

            // Защита от двойного срабатывания
            if (!urgent) {
                urgent = true;

                let picker = $('.js-courier-date-picker');

                if (picker.html() !== new Date().getDate().toString())
                    resetCourierDate();

                setDefaultTimeTo();
            }
        } else {
            urgent = false;
            courierUrgentCheckbox.prop("checked", false);
            $('.js-courier-urgent[value=false]').prop("checked", true);
            $('.js-delivery-to-date').show('slow');
        }
    }

    function init() {
        $('.js-courier-loyalty-eggs-lower-bound').on('keyup', function () {
            let currentPoints = $('.js-courier-loyalty-points').val();
            $('.js-courier-loyalty-points').val($(this).val());
            $('.js-courier-loyalty-eggs-lower-bound').val(currentPoints);
            $('.js-courier-loyalty-points').trigger('input')
        });

        $('.js-pickup-loyalty-eggs-lower-bound').on('keyup', function () {
            let currentPoints = $('.js-pickup-loyalty-points').val();
            $('.js-pickup-loyalty-points').val($(this).val());
            $('.js-pickup-loyalty-eggs-lower-bound').val(currentPoints);
            $('.js-pickup-loyalty-points').trigger('input')
        });

        if ($('.js-courier-selection').is(':visible'))
            $('#modalCashBack').attr('active', true);


        showStickyPart();

        confirmEnteringAddress();

        closeEnteringAddress();

        resetFullAddress();

        editEnteringAddress();

        changeCityFromForm();

        //#tag: cp-init-function

        //**** Cloud Payments INIT START ****

        checkStatusEvent();
        checkStatusInit();
        checkPayTypeEvent();
        checkPayTypeInit();
        initInputMask();
        //**** Cloud Payment INIT END ****/

        $('.js-entrance-and-floor-fill-mobile').click(function () {

            var entrance = $('.js-order-entering-address-entrance');
            var floor = $('.js-order-entering-address-floor');
            $(this).hide();

            if (entrance.val().length === 0 && floor.val().length === 0) {
                entrance.val("-");
                floor.val("-");
            } else {
                if (entrance.val().length === 0) {
                    entrance.val("-");
                    entrance.removeClass('has-error');
                }
                if (floor.val().length === 0) {
                    floor.val("-");
                    floor.removeClass('has-error');
                }
            }
            $('.js-confirm-entering-address').trigger('click');
        });

        $('.js-entrance-and-floor-fill').click(function () {

            var entrance = $('.js-order-info-entrance');
            var floor = $('.js-order-info-floor');
            $(this).hide();
            isCalledCheckPromoTime = false;

            if (entrance.val().length === 0 && floor.val().length === 0) {
                entrance.val("-");
                floor.val("-");
            } else {
                if (entrance.val().length === 0) {
                    entrance.val("-");
                    entrance.removeClass('has-error');
                }
                if (floor.val().length === 0) {
                    floor.val("-");
                    floor.removeClass('has-error');
                }
            }
            createOrder();
        });

        onToOrderDeliveryClick();

        $('.js-create-order-repeat').click(createOrder);

        $('.js-apply-coupon').click(function () {
            coupon = $('.js-cart-item-coupon').val();
        });

        updateWorkingTimeDays();

        $('.js-success-cookie').click(function () {
            AnimationsService.animate.successOrder();
            $('.js-success-cookie').off();
        });

        $('.js-back-button').click(AppService.redirectToBack);

        $('.js-courier-order-info-phone,.js-pickup-order-info-phone').change(onChangePhone);
        $('.js-order-info-time-to, .js-order-info-time-to-mobile').change(onChangeDeliveryTime);
        $('.js-time-field, .js-time-field-mobile').change(onChangePickUpTime);
        $('.js-courier-order-info-recall,.js-courier-order-info-recall-mobile,.js-pickup-order-info-recall').change(onClickCheckbox);
        $('.js-any-time-field').change(() => {
            // Юзер поменял время
            urgent = false;
        });
        $('select.js-shop-select').on('change', function () {
            var selectedOption = $('.js-shop-select option:selected');
            var width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
            var value = $(this).val();
            var dateTo = $('.js-pickup-date-field.desktop');
            var time = $('.js-time-field');
            var payment = $('.js-pickup-pay-type-radio:checked');
            if (width < 768) {
                selectedOption = $('.js-shop-select-mobile option:selected');
                value = $('.js-shop-select-mobile').val();
                dateTo = $('.js-pickup-date-field.mobile');
                time = $('.js-time-field-mobile');
            }

            var element = $('.js-time-field,.js-time-field-mobile');
            notAllCategoriesAreAvailable = selectedOption.data('not-all-categories-are-available');
            var minuteToStopOrder = selectedOption.data('minute-to-stop-order');
            var startHour = selectedOption.data('start-hour');
            var startMinute = selectedOption.data('start-minute');
            var endHour = selectedOption.data('end-hour');
            var endMinute = selectedOption.data('end-minute');
            var delayToStart = element.data('pickup-constraint');
            var unavailableCategories = selectedOption.data('unavailable-categories');
            if (unavailableCategories !== undefined) {
                var categories = unavailableCategories.slice(1, -1);
            }

            $('.bootstrap-select>.dropdown-toggle').removeClass('has-error-shop-select');
            $('.js-delivery-proposal').hide();
            $('.js-to-stop-order-message').hide();

            if (value === 'Выберите СушиВёсла') {
                $('.bootstrap-select>.dropdown-toggle').addClass('has-error-shop-select');
            }

            let dateToVal;
            if (dateTo.val())
                dateToVal = dateTo.val();
            else
                dateToVal = formatDateDMY(new Date());

            if (checkShopFirstTime === false) {
                if (value != 'Выберите СушиВёсла') {
                    if (notAllCategoriesAreAvailable) {
                        isValidate = false;
                        $('.js-delivery-proposal').show();
                        $('.js-delivery-proposal-error').addClass('has-error');
                        $('.js-unavailable-categories-error').text('В указанном ресторане не готовят: ' + categories);
                        $('.bootstrap-select>.dropdown-toggle').addClass('has-error-shop-select');
                    }
                    if (dateToVal != getNowDate()) {
                        initToStopOrderStatus(minuteToStopOrder, startHourInNewDay, startMinuteInNewDay, endHourInNewDay, endMinuteInNewDay, width, delayToStart);
                    } else {
                        initToStopOrderStatus(minuteToStopOrder, startHour, startMinute, endHour, endMinute, width,
                            delayToStart)
                    }
                } else {
                    isValidate = false;
                    $('.bootstrap-select>.dropdown-toggle').addClass('has-error-shop-select');
                }
            } else {
                checkShopFirstTime = false;
            }

            return false;
        });

        $('.js-click-delivery').on('click', function () {
            $('#pickupModal').modal('hide');
            $('#courierModal').modal('show');

            return false;
        });

        initOrderDialog();

        initDeliverySelection();

        initDatepicker();

        initDeliverySelectionItem();

        updateWorkTimeLabel();

        streetSuggestions();

        houseSuggestions();

        initializeEnteringAddress();

        pickupSlider();

        deliverySlider();

        initDeliveryUrgentSelect();

        refreshWorkingTimeLabel();

        if ($('main.content').attr('data-general-tab') == 'basket') {
            checkOrderType();
            getMinOrderPrice();
        }
        $('.js-order-sticky-part-show').click(function () {
            showStickyPart();
        })

        $('.js-pickup-order-info-comment , .js-courier-order-info-comment , .js-courier-order-info-comment-mobile').change(function () {
            checkComment($(this));

        });
    }

    return {
        init: init,
        externalUpdateDeliveryStatus: externalUpdateDeliveryStatus
    };
})();

$(CartService.init);